import {FC} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as fa from "@fortawesome/free-solid-svg-icons";

export const AutocompletePlaceholder: FC<{label: string}> = (props) => {
  return <div className={"flex flex-col text-sm font-medium text-slate-900 w-full max-w-md"}>
    {props.label}
    <div className={"relative mt-1"}>
      <div className={"border-2 border-slate-200 outline-slate-700 text-black rounded-xs text-base font-normal px-2 h-10 w-full"} />
      {/* Chevron icon*/}
      <div className={"absolute top-0 right-2 h-full flex items-center justify-end"}>
        <FontAwesomeIcon icon={fa.faChevronDown} className={"text-xs text-slate-900"} />
      </div>
    </div>
  </div>
}
